import { usePluginMessages } from '../../../composition/plugin-runtime';
import { useRewardedAd, type RewardedAdParams } from '../composition/use-rewarded-ad';

export function RewardWidget(props: RewardedAdParams) {
  const t = usePluginMessages('ad-reward');
  const { visible, busy, result, watch } = useRewardedAd(props);
  // 게이트가 닫혀 있으면 자리 자체를 그리지 않는다 — 버튼도 안내도 없다 (prd/112 AC-030)
  if (!visible) return null;
  return (
    <section aria-label={t('label')}>
      <button type="button" onClick={() => void watch()} disabled={busy}>
        {t('watch')}
      </button>
      {result === 'credited' && <p role="status">{t('result.credited')}</p>}
      {(result === 'unavailable' || result === 'failed') && <p role="alert">{t(`result.${result}`)}</p>}
    </section>
  );
}

/** 슬롯은 props 없는 컴포넌트를 받는다 — 플러그인 설정을 묶어 넘긴다 */
export function rewardWidget(props: RewardedAdParams) {
  return function BoundRewardWidget() {
    return <RewardWidget {...props} />;
  };
}
